import { useState } from 'react';
import styles from '@features/instructions/sections/GroupList/components/InstructionListBlock/InstructionListItem.styles';
import ErrorBoundary from '@components/errors/ErrorBoundary';
import Heading from '@components/Heading/Heading';
import { WindowType } from '@typescript/index';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
type PropsType = {
  title: string | null;
  children: React.ReactNode;
  windowType: WindowType;
  deliveryOpen?: boolean;
};
const InstructionListItem = ({
  title,
  children,
  windowType,
  deliveryOpen = false
}: PropsType) => {
  const [showDetails, toggleDetails] = useState(deliveryOpen || false);
  return <ErrorBoundary>
      <div sx={styles.instructionListItem}>
        {title && <div sx={styles.headerContainer}>
            <Button variant="link" cy="CloseButton" fullWidth addSx={styles.addButton} onClick={() => toggleDetails(!showDetails)}>
              <Heading h={4} headingType={4}>
                {title}
              </Heading>
              <Icon icon={`${showDetails ? 'Minus' : 'Add'}`} size={windowType === WindowType.mobile || windowType === WindowType.tablet ? '18px' : '30px'} />
            </Button>
          </div>}
        {showDetails && children}
      </div>
    </ErrorBoundary>;
};
export default InstructionListItem;